import { useMutation } from 'react-query';
import { axiosInstance } from '@shared/lib/axios';
import { MUTATIONS_INFO } from '@shared';
export type TUseRequestResetPasswordPayload = {
  email: string;
};
export const fetchRequestResetPassword = (payload: TUseRequestResetPasswordPayload) => axiosInstance.post(MUTATIONS_INFO.requestResetPassword, payload);
export const useRequestResetPassword = () => useMutation<unknown, unknown, TUseRequestResetPasswordPayload>(fetchRequestResetPassword);